import React from 'react';

import useTriggeredRequest from '@api/hooks/useTriggeredRequest';
import AccountClientRequests from '@api/requests';

import { getCurrentUser } from '@app/redux/auth/auth.selectors';
import { useAppSelector } from '@app/redux/hooks';

import { Grid, TextField, Typography } from '@mui/material';

import { BackSubmitButton } from '@components/forms/verifyEmail/styles';
import SubmitButton from '@components/submitButton';

function EnablePhone2FA({ onDecline }: { onDecline: () => void }) {
	const { startRequest: enable2FA, isPending } = useTriggeredRequest(AccountClientRequests.MFA.toggleMFA);
	const currentUser = useAppSelector(getCurrentUser);

	const handleEnablePhone2FA = () => enable2FA({ enable_phone_mfa: true, mfa_enabled: true });

	return (
		<Grid container mb={1}>
			<Grid item xs={12} mt={4} sx={{ order: 3 }}>
				<Typography variant="body1" mb={2} sx={{ fontSize: 16, fontWeight: 400 }}>
					Please confirm enabling 2FA:
				</Typography>
				<TextField fullWidth name={'phone'} label={'Phone'} autoComplete="off" disabled value={currentUser?.phone} />
			</Grid>

			<Grid item xs={12} mt={4} sx={{ order: 6 }}>
				<Grid container spacing={3}>
					<Grid item xs={6}>
						<BackSubmitButton
							disabled={isPending}
							onClick={onDecline}
							variant="contained"
							color="secondary"
							type="button"
							fullWidth
						>
							Back
						</BackSubmitButton>
					</Grid>
					<Grid item xs={6}>
						<SubmitButton label={'Enable 2FA'} disabled={isPending} onClick={handleEnablePhone2FA} />
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
}

export default EnablePhone2FA;
